import { v4 as uuidv4 } from "uuid";
import { INTERPRETER_BASE_URL } from "../config/runtime";

const CHAT_URL = INTERPRETER_BASE_URL
  ? `${INTERPRETER_BASE_URL}/api/chat`
  : `/api/chat`;
const A2A_URL = INTERPRETER_BASE_URL
  ? `${INTERPRETER_BASE_URL}/api/a2a`
  : `/api/a2a`;

// Sends a chat message and returns the parsed response.
// Throws on network/HTTP error — caller should show an error message.
export const sendChatMessage = async ({
  userQuery,
  userId,
  sessionId,
  tabType,
  fileId,
  currentFolderId,
  attachedFiles,
  dpmUuid,
  currentStep,
  selectedOption,
}) => {
  const dpmContext = {
    ...(dpmUuid && { dpm_uuid: dpmUuid }),
    ...(currentStep != null && { current_step: currentStep }),
  };
  const res = await fetch(CHAT_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      user_query: userQuery,
      user_id: userId.toString(),
      session_id: sessionId,
      tab_type: tabType,
      ...(localStorage.getItem("selectedOrganizationId")
        ? { organization_id: localStorage.getItem("selectedOrganizationId") }
        : {}),
      ...(tabType === "toc-editor" && fileId && { file_id: fileId }),
      ...(currentFolderId != null && { folder_id: currentFolderId }),
      ...(attachedFiles?.length > 0 && { attached_files: attachedFiles }),
      ...(Object.keys(dpmContext).length > 0 && { dpm_context: dpmContext }),
      ...(selectedOption && { selected_option: selectedOption }),
    }),
  });
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  return res.json();
};

// Fetches prior chat history for a session. Returns [] on any failure —
// history is non-critical, so the caller doesn't need to handle errors specially.
export const getChatHistory = async (userId, sessionId) => {
  const res = await fetch(A2A_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: uuidv4(),
      method: "GetChatHistory",
      params: {
        metadata: {
          user_id: userId.toString(),
          ...(localStorage.getItem("selectedOrganizationId")
            ? {
                organization_id: localStorage.getItem("selectedOrganizationId"),
              }
            : {}),
        },
        message: {
          parts: [{ type: "data", data: { session_id: sessionId } }],
        },
      },
    }),
  });
  if (!res.ok) return [];
  const data = await res.json();
  return (data.result?.artifact?.parts ?? []).flatMap(
    p => p.data?.chat_history || [],
  );
};
